define('models/causes/cause',["backbone",
     "models/shared/settings/settingvalue_collection",
     "models/shared/bankaccount/bankaccount",
     "models/causes/causeattribute_collection",
     "models/shared/lookups/systext"
], function (Backbone, AccountSettingList, BankAccount, AccountAttributeList) {
    var Account = Backbone.Model.extend({
        urlRoot: function () {
            if (!pf.session.get("auth")) {
                return pf.accountsURL + "/Discover/" + this.ID;
            }
            if (this.instanceURL)
                return this.instanceURL;
            var url = pf.accountsURL;
            if (this.ID != null) {
                url += "/" + this.ID;
            }
            return url;
        },
        initialize: function (options) {
            options = options || {};
            this.instanceURL = options.instanceURL;
            this.accountBalance = options.AB;
            this.ID = options.ID;            
        },
        defaults:{
            accountBalance: 0,
            TotalContributions:0,
            bankAccount :new BankAccount( {parse:true})
        },
        parse: function (data) {
            //_gaq.push(['_trackEvent', 'Consumer', 'Cause', data.AN + '-' + data.AGID, null, null]);
            gAnalytics('Cause', data.AN + ' - ' + data.AGID, '');

			var response = {};
			response.accountName = data.AN;
			response.parentAccountName = data.PAN;
			response.managedByGUID = data.MBID;
			response.managedBy = data.MB;
			response.accountGUID = data.AGID;
			response.accountID = data.AID;
			response.addressLine1 = data.A1;
			response.addressLine2 = data.A2;
			response.city = data.C;
			response.state = data.S;
			response.zipCode = data.Z;
			response.zipCodeID = data.ZID;
			response.country = data.CN;
			response.parentAccountID = data.PAID;
			response.parentAccountGUID = data.PAGID;
			response.accountTypeID = data.ATID;
			response.accountCategoryID = data.ACID;
			response.accountCategory = data.ACT;
			response.accountCode = data.AC;
			response.certificationTypeID = data.CTID;
			response.certificationType = data.CTT;
			response.accountStatusTypeID = data.ASTID;
			if (this.ID) {
			    response.photo = buildImageURL(pf.enums.entityTypeCodeEnum.Account, this.ID, pf.enums.imageTypeGUIDEnum.Actual, data.P);
			    response.logo = buildImageURL(pf.enums.entityTypeCodeEnum.Account, this.ID, pf.enums.imageTypeGUIDEnum.Profile, data.L);
			}
			else {
			response.photo = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Actual, data.P);
			response.logo = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Profile, data.L);
			response.thumbnail = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Thumbnail, data.L);
			}
			response.shortDescription = data.SD;
			response.description = data.D;
			response.financial = data.F;
			response.financialTypeID = data.FTID;
			response.financialType = data.FTT;
			response.targetAmount = data.TA;
			response.targetAmountDueBy = data.TADB;
			response.accountBalance = data.AB;
			response.startDT = data.SDT;
			response.endDT = data.EDT;
			response.taxIDLastFour = data.TID;
			response.game = data.G;
			response.Internal = data.I;
			response.Private = data.PT;
			response.urlTerm = data.UT;
			response.twitterAddress = data.TAD;
			response.facebookURL = data.FBU;
			response.googleURL = data.GU;
			response.minPercent = data.MP;
			response.PFSalesPersonID = data.PFSP;
			response.enabled = data.E;
			response.disabledDT = data.DDT;
			response.disabledByUserID = data.DUID;
			response.createdDT = data.CDT;
			response.createdByUserID = data.CUID;
			response.lastUpdateDT = data.LUDT;
			response.participantCount = data.PC;
			response.allocatorsCount = data.ALC;
			response.invitationsSent = data.IS;
			response.accountType = data.ATY;
			response.accountStatusType = data.AST;
			response.isMember = data.IM;
			response.isEditable = data.IE;
			//response.TotalContributors = data.TC;
			response.TotalParticipants = data.TP;
			response.RebatesEarned = data.RED;
			response.TotalDonations = data.DNS;
			//response.InvitationsSend = data.INS;
			//response.InvitationsAccepted = data.INA;
			response.isFeatured = data.IFC;
			response.stateID = data.SID;
			response.participantRoleTypeID = data.PRTID;
			if (!data.ASTG)
			    data.ASTG = new AccountSettingList({ ID: data.AGID, SF: pf.enums.settingFor.Account });
			else
			    data.ASTG.SF = pf.enums.settingFor.Account;

			//if (data.ASTG && data.ASTG.length && data.ASTG.length > 0 && data.ASTG[0] && data.ASTG[0].SID)
			//{
			//    for (var x in data.ASTG) {
			//        if (data.ASTG[x].SID == 28) {
			//            response.financial = data.ASTG[x].SV == 1 ? true : false;
			//        }
			//    }
			//}

			response.AccountSettings = new AccountSettingList(data.ASTG, { parse: true });
            //populate 3 setting attributes
			if (response.AccountSettings != null && response.AccountSettings.length >= 1)  //1 is the default
			{
			    //var CausePrivateSetting = response.AccountSettings.models.find(function (model) { return model.get('SID') == enums.CauseAttributeTypes.CausePrivate; });
			    var CausePrivateSetting = $.grep(response.AccountSettings.models, function (e) { return e.SID == enums.CauseAttributeTypes.CausePrivate; });
			    if (CausePrivateSetting.length > 0)
			        CausePrivateSetting = CausePrivateSetting[0];
			    if (CausePrivateSetting.SV && CausePrivateSetting.SV.trim())
			        response.CausePrivate = CausePrivateSetting.SV.trim() == "1" ? true : false;
			    var ApprovalRequiredSetting = $.grep(response.AccountSettings.models, function (e) { return e.SID == enums.CauseAttributeTypes.ApprovalRequired; });
			    if (ApprovalRequiredSetting.length > 0)
			        ApprovalRequiredSetting = ApprovalRequiredSetting[0];
			    if (ApprovalRequiredSetting.SV && ApprovalRequiredSetting.SV.trim())
			        response.ApprovalRequired = ApprovalRequiredSetting.SV.trim() == "1" ? true : false;

			    var ShowTransHistoryToParticipantsSetting = $.grep(response.AccountSettings.models, function (e) { return e.SID == enums.CauseAttributeTypes.ShowTransHistoryToParticipants; });
			    if (ShowTransHistoryToParticipantsSetting.length > 0)
			        ShowTransHistoryToParticipantsSetting = ShowTransHistoryToParticipantsSetting[0];
			    if (ShowTransHistoryToParticipantsSetting.SV && ShowTransHistoryToParticipantsSetting.SV.trim())
			        response.ShowTransHistoryToParticipants = ShowTransHistoryToParticipantsSetting.SV.trim() == "1" ? true : false;

			    if (response.participantRoleTypeID == enums.participantRoleTypeEnum.Manager
                    || response.participantRoleTypeID == enums.participantRoleTypeEnum.CoManager
                    || response.participantRoleTypeID == enums.participantRoleTypeEnum.NonProfitManager
                    || response.participantRoleTypeID == enums.participantRoleTypeEnum.NonProfitCoManager)

			    {
			        response.ParticipantsCanPost = true;
			    }
			else
			{
			    var ParticipantsCanPostSetting = $.grep(response.AccountSettings.models, function (e) { return e.SID == enums.CauseAttributeTypes.ParticipantsCanPost; });
			    if (ParticipantsCanPostSetting.length > 0)
			    {
			        ParticipantsCanPostSetting = ParticipantsCanPostSetting[0];
			        if (ParticipantsCanPostSetting.SV && ParticipantsCanPostSetting.SV.trim())
			            response.ParticipantsCanPost = ParticipantsCanPostSetting.SV.trim() == "1" ? true : false;
			    }
			    else 
			        response.ParticipantsCanPost = true;
			}
			}
			else {
			    response.CausePrivate = false;
			    response.ApprovalRequired = false;
			    response.ShowTransHistoryToParticipants = false;
			    response.ParticipantsCanPost = true;
			}
			//store.setStoreItem(enums.modelsEnum.CAUSESETTINGS, { ID: data.AGID, Data: data.ASTG });
			response.stateID = data.SID;
			response.bankAccount = new BankAccount(data.BA, { parse: true });
			response.bankAccount = data.BA;
            
			response.MaximumPossibleAmount = data.MPA;			
			response.AccountAttributeList = new AccountAttributeList(data.AAL, { parse: true });
			response.TotalContributions = data.TCS;
			response.AllocationPercentage = data.ACP;
			response.IsAllocating = data.IAC;
			response.TotalRaised = data.TRD;
			response.ParticipantStatusID = data.PSID;
			response.AllocationEnabled = data.AE;
			response.IsParticipantListVisible = data.IPLV;
			if (response.IsParticipantListVisible || response.participantRoleTypeID == 2 ||
                response.participantRoleTypeID == 3 || response.participantRoleTypeID == 5 || response.participantRoleTypeID == 6)
			    response.ShowParticipantList = true;
			
			return response;
        },
      
        validation: {
            accountName: {
                required: true,
                msg: sysText['FV']['required']['causeName'],
            },
            accountTypeID: {
                required: true,
                fn: function (value, attr, computedState) {
                    if (value < 0) {
                        var errmsg = sysText['FV']['required']['causeType'];
                        return errmsg;
                    }
                }
            },
            accountCategoryID: {
               required: true,
               fn: function (value, attr, computedState) {
                    if (value < 0) {
                        var errmsg = sysText['FV']['required']['causeCategory'];
                        return errmsg;
                    }
                }
            },
            stateID: {
                required: true,
                msg: sysText['FV']['required']['state'],
                fn: function (value, attr, computedState) {
                    if (value < 0) {
                        var errmsg = sysText['FV']['required']['state'];
                        return errmsg;
                    }
                }
            },
            //city: {
            //    required: true,
            //    msg: sysText['FV']['required']['city'],
            //    //fn: function (value, attr , computedState) {
            //    //    var pattern = new RegExp(/^[a-zA-Z. ]+$/i);
            //    //    if (!pattern.test(city))
            //    //    {
            //    //        var errmsg = sysText['FV']['invalid']['value'];
            //    //        return errmsg;
            //    //    }

            //    //    if (city == null || city == "") {
            //    //        var errmsg = sysText['FV']['required']['city'];
            //    //        return errmsg;
            //    //    }
            //    //}
            //},
            //description: {
            //    fn: function (value, attr, computedState) {
            //        var pattern = new RegExp(/^[a-zA-Z0-9.:,&@$;-]+$/i);
            //        if (!pattern.test(description)) {
            //            var errmsg = sysText['FV']['invalid']['value'];
            //            return errmsg;
            //        }
            //    }
            //},
            // urlTerm: {
            //     required: false,
            //     fn: function (value, attr, computedState) {
            //         if (value == null || value == "") {
            //             var errmsg = sysText['FV']['required']['causeURL'];
            //             return errmsg;
            //         }

            //         if (value) {
            //             if (value !== null && value !== "") {
            //                 var pattern = new RegExp(/^[a-zA-Z0-9._-]+$/i);
            //                 if (!pattern.test(value)) {
            //                     var errmsg = sysText['FV']['invalid']['causeURLChars'];
            //                     return errmsg;
            //                 }
            //             }
            //         }
            //     }
            // },
        },
		save: function (currentAttributes, options) {
			options       = options || {};
			currentAttributes = currentAttributes || {};

			var data = {};

			data.AN = this.attributes.accountName;
			data.PAN = this.attributes.parentAccountName;
			data.MB = this.attributes.managedBy;
			data.AGID = this.attributes.accountGUID;
			data.AID = this.attributes.accountID;
			data.A1 = this.attributes.addressLine1;
			data.A2 = this.attributes.addressLine2;
			data.C = this.attributes.city;
			data.S = this.attributes.state;
			data.SID = this.attributes.stateID;
			data.Z = this.attributes.zipCode;
			data.ZID = this.attributes.zipCodeID;
			data.CN = this.attributes.country;
			data.PAID = this.attributes.parentAccountID;
			data.PAGID = this.attributes.parentAccountGUID;
			data.ATID = this.attributes.accountTypeID;
			data.ACID = this.attributes.accountCategoryID;
			data.AC = this.attributes.accountCode;
			data.CTID = this.attributes.certificationTypeID;
			data.ASTID = this.attributes.accountStatusTypeID;
			data.P = getImageFileName(this.attributes.photo);
			data.L = getImageFileName(this.attributes.logo);
            data.SD = this.attributes.shortDescription;
			data.D = this.attributes.description;
			data.F = this.attributes.financial;
			data.FTID = this.attributes.financialTypeID;
			data.TA = this.attributes.targetAmount;
			data.TADB = this.attributes.targetAmountDueBy;
			data.AB = this.attributes.accountBalance;
			
			data.SDT = this.attributes.startDT;
			data.EDT = this.attributes.endDT;
			data.G = this.attributes.game;
			data.I = this.attributes.Internal;
			data.PT = this.attributes.Private;
			data.UT = this.attributes.urlTerm;
			data.TAD = this.attributes.twitterAddress;
			data.FBU = this.attributes.facebookURL;
			data.GU = this.attributes.googleURL;
			data.MP = this.attributes.minPercent;
			data.PFSP = this.attributes.PFSalesPersonID;
			data.E = this.attributes.enabled;
			data.DDT = this.attributes.disabledDT;
			data.DUID = this.attributes.disabledByUserID;
			data.CDT = this.attributes.createdDT;
			data.CUID = this.attributes.createdByUserID;
			data.LUDT = this.attributes.lastUpdateDT;
			data.PC = this.attributes.participantCount;
			data.ALC = this.attributes.allocatorsCount;
			data.IS = this.attributes.invitationsSent;
			data.ATY = this.attributes.accountType;
			data.AST = this.attributes.accountStatusType;
			data.IM = this.attributes.isMember;
			data.IE = this.attributes.isEditable;
			data.BA = this.attributes.bankAccount;
			
			
			data.MPA = this.attributes.MaximumPossibleAmount;
		
			data.AAL = this.attributes.AccountAttributeList;
			this.attributes = data;

			return Backbone.Model.prototype.save.call(this, this.attributes, options);
		}
        });
    return Account;
});

